import { render } from "./speakers.vue?vue&type=template&id=289c050c&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=289c050c&lang=scss&scoped=true"
import "./speakers.vue?vue&type=style&index=1&id=289c050c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-289c050c"

export default script